import * as React from "react";
import {onboardingEmailId} from "IncompleteInfoV2/utils";
import "IncompleteInfoV2/BankStatementV2/BSModes/OnboardEmail/style.scss";

interface IProps {
    userId: number;
    availableStatementCount?: number;
    allowedToUpload?: boolean;
}

const OnboardEmail = (props: IProps) => {
    return (
        <div className="onboard-email-container">
            <h6>Email scanned pdf statement</h6>
            <p>
                <a href={`mailto: ${onboardingEmailId}?subject=BANK_STATEMENT_${props.userId}_${props.availableStatementCount}_${props.allowedToUpload ? "1" : "0"}`}
                   className="email-link">
                   Click here to Email
                </a>
            </p>
        </div>
    );
};

export default OnboardEmail;
